var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M92.194,3.808a13,13,0,1,0,3.365,5.828,13,13,0,0,0-3.365-5.828ZM88.731,7.27c.124.124.3.5.18.627l-5.1,5.1,5.1,5.1c.126.122-.056.5-.18.627s-.5.3-.627.18l-5.1-5.1-5.1,5.1c-.122.126-.5-.055-.627-.18s-.3-.5-.18-.627L82.2,13l-5.1-5.1c-.126-.122.055-.5.18-.627s.5-.3.627-.18l5.1,5.1,5.1-5.1c.122-.126.5.055.627.18Z",
    transform: "translate(-70.002)",
    fill: "#de2525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.b8cc1bf59df10f2e9dd1fb8847a00aea.svg";
export { ForwardRef as ReactComponent };